<template>
    <span v-if="p" class="app--icon fa-layers">
        <i :class="[pType, pFW, p.icon, first]" :data-fa-transform="pTransform" :data-fa-mask="pMask"></i>
        <i v-if="s && s.hasOwnProperty('background')" :class="['fas', sFW, s.background, background]" :data-fa-transform="sTransform"/>
        <i v-if="s" :class="[sType, sFW, s.icon, second]" :data-fa-transform="sTransform" :data-fa-mask="sMask"></i>
    </span>
</template>

<script>
    import Icons from './../icons'
    export default {
    	props: {
            transform:  { type: String, default: '' },
            type:       { type: String, default: '' },
    		value:      { type: String, default: '' },
            first:      { type: String, default: '' },
            second:     { type: String, default: '' },
            background: { type: String, default: '' },
    	},
        computed: {
            p() { 
                return Icons.hasOwnProperty(this.value) ? Icons[this.value] : null 
            },
            pType() {
                return this.type ? this.type : (this.p && this.p.type ? this.p.type : 'fal')
            },
            pTransform() {
                return this.transform ? this.transform : (this.p && this.p.transform ? this.p.transform : '')
            },
            pMask() {
                return this.p && this.p.mask ? this.p.mask : ''
            },
            pFW() {
                return this.p && this.p.fw && this.p.fw == true ? 'fa-fw' : ''
            },
            s() {
                return this.p && this.p.secondary ? this.p.secondary : null
            },
            sType() {
                return this.s && this.s.type ? this.s.type : this.pType
            },
            sTransform() {
                return this.s && this.s.transform ? this.s.transform : this.pTransform
            },
            sMask() {
                return this.s && this.s.mask ? this.s.mask : ''
            },
            sFW() {
                return this.s && this.s.fw ? (this.s.fw == true ? 'fa-fw' : '') : this.pFW
            },
        }
    }
</script>
